import { useRecoilState, useSetRecoilState } from "recoil";
import {
  attendanceEmpModalIdState,
  attendanceFilterState,
  modalOpenState,
  modalTitle,
} from "../../utils/atoms/atoms";
import CustomModal from "../CustomModal";
import AttendanceMonthModalBody from "./AttendanceMonthModalBody";
import AttendanceYearsModalBody from "./AttendanceYearsModalBody";

const AttendanceButtonModal = ({ empCode }: { empCode: any }) => {
  const setAttendanceEmpModalId = useSetRecoilState(attendanceEmpModalIdState);
  const setModalIsOpen = useSetRecoilState(modalOpenState);
  const setGlobalFilter = useSetRecoilState(attendanceFilterState);
  const [attdModalTitle, setAttdModalTitle] = useRecoilState(modalTitle);
  return (
    <div className="">
      <button
        onClick={() => {
          setGlobalFilter("");
          setAttendanceEmpModalId(empCode);
          setModalIsOpen(true);

          //DO NOT REMOVE (to rerender modal)
          setAttdModalTitle("");
        }}
        className="styled-btn--dark"
        data-bs-toggle="modal"
        data-bs-target="#attendanceCurrentModal"
      >
        Show
      </button>
    </div>
  );
};

export default AttendanceButtonModal;
